import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {SeoService} from "@biletix/core/services/seo.service";
import {ApiService} from "@biletix/core/services/api.service";
import {ActivatedRoute,NavigationEnd, Router} from "@angular/router";
import {I18nService} from "@biletix/core/services/i18n.service";
import {RegionService} from "@biletix/core/services/region.service";
import {TranslateService} from "@ngx-translate/core";
import {LocaleSelectorComponent} from "@biletix/core/common/locale-selector.component";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {Platform} from "@angular/cdk/platform";
import {ConsoleLogger} from "@biletix/core/logging/console.logger";
import {CartTimeoutService} from "@biletix/core/services/cart-timeout.service";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import { isPlatformServer } from '@angular/common';
import { environment } from '@biletix/env';
import { WINDOW } from './core/common';
import { ChannelService } from './core/services/channel.service';
import { GtmService } from '@biletix/core/services/gtm.service';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';

//declare const gtag: Function;


@Component({
    selector: 'btx-root',
    templateUrl: './app.html',
    styleUrls: ['./app.scss'],
    standalone:false
})
export class AppComponent extends LocaleSelectorComponent implements OnInit {


    constructor(private seo: SeoService,
                private i18n: I18nService,
                private translate: TranslateService,
                private apiService: ApiService,
                private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,
                public platform: Platform,
                private channelService: ChannelService,
                private consoleLogger: ConsoleLogger,
                private timeoutService: CartTimeoutService,
                private ticketSaleService: TicketSaleService,
                private router: Router,
                private gtmService: GtmService,
                @Inject(PLATFORM_ID) private platformId: string,
                @Inject(WINDOW) private window: Window
    ) {
        super(translate, i18n);

      /*   this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              gtag('config', 'UA-27820024-1', { 'page_path': event.urlAfterRedirects });
            }      
          }) */

    }

    /**
     *
     */
    ngOnInit(): void {
        this.initGtmWhenIdle();

        //Set
        if (this.platform.ANDROID)
            this.consoleLogger.log("Platform : ANDROID");


        //
//        this.initSeo();

        //
        this.addSvgIcons();

        // push GTM data layer for every visited page
        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
                // const gtmTag = {
                //     event: 'page',
                //     pageName: item.url
                // };
        
                // this.gtmService.pushTag(gtmTag);
            }
        });
        if(!isPlatformServer(this.platformId)){
            //this.addScript("//static.queue-it.net/script/queueconfigloader.min.js", 'queueConfigLoader');
        }
    
    }

    /**
     * GTM (ve onun tetiklediği OneTrust, GA4, TikTok, GPT) ~450 KB üçüncü taraf JS'i
     * hidrasyonla aynı anda ana thread'e bindiriyordu. Ana thread boşalınca ya da
     * en geç 3 sn sonra yüklenir. dataLayer push'ları GtmService içinde dizide
     * biriktiği için bu sürede atılan event'ler kaybolmaz.
     */
    private initGtmWhenIdle(): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        const start = () => this.gtmService.init('GTM-K4QMLG');
        const idle = (this.window as any).requestIdleCallback as ((cb: () => void, opts?: { timeout: number }) => number) | undefined;
        if (idle) {
            idle(start, { timeout: 3000 });
        } else {
            setTimeout(start, 2000);
        }
    }

    /**
     *  Harici svg iconları mat-icon ile beraber kullanmak için harici svg iconları register eden metod.
     *
     *   @example:
     *    <mat-icon [svgIcon]="currentLocale.lang"></mat-icon>
     *    <mat-icon svgIcon="en"></mat-icon>
     *    <mat-icon [svgIcon]="'tr'"></mat-icon>
     */
    addSvgIcons() {

        // TODO: SVG olmalıdır.
        const internalSvgIcons: { iconName: string, iconUrl: string }[] = [
            {iconName: 'en', iconUrl: "assets/images/flag/en.svg"},
            {iconName: 'tr', iconUrl: "assets/images/flag/tr.svg"},
            {iconName: 'location', iconUrl: "assets/images/icon/location.svg"},
            {iconName: 'ticket', iconUrl: "assets/images/icon/ticket.svg"},
            {iconName: 'check_stroke', iconUrl: "assets/images/icon/check_stroke.svg"},
            {iconName: 'timer', iconUrl: "assets/images/icon/bg-orange-timer.svg"},
            {iconName: 'refresh', iconUrl: "assets/images/icon/refresh.svg"},
            {iconName: 'gray_right_chevron', iconUrl: "assets/images/icon/right-chevron.svg"},
        //    Social media icon
            {iconName: 'copy_link', iconUrl: "assets/images/icon/link.svg"},
            {iconName: 'email', iconUrl: "assets/images/icon/email.svg"},
            {iconName: 'messenger', iconUrl: "assets/images/icon/messenger.svg"},
            {iconName: 'messenger_circle', iconUrl: "assets/images/icon/messenger_circle.svg"},
            {iconName: 'sms', iconUrl: "assets/images/icon/sms.svg"},
            {iconName: 'whats_app', iconUrl: "assets/images/icon/whatsApp.svg"},
        ];

        //
        const domain = (isPlatformServer(this.platformId)) ? 'https://www.biletix.com/' : ''; 
        //this._matIconRegistry.addSvgIcon('loader', this._domSanitizer.bypassSecurityTrustResourceUrl(domain + svgU
        internalSvgIcons.forEach(item => {
                this.matIconRegistry.addSvgIcon(
                    item.iconName,
                    this.domSanitizer.bypassSecurityTrustResourceUrl(domain+item.iconUrl)
                );
            }
        );

    }


    // addScript(source: string, elementId: string): Promise<boolean> {
    //     return new Promise<boolean>((resolve, reject) => {
    //         const script = document.createElement('script');
    //         script.id = elementId;
        
    //         // Set custom attributes using setAttribute
    //         script.setAttribute('data-queueit-intercept-domain', this.getHostName());
    //         script.setAttribute('data-queueit-spa', 'true'); // Set value as string
    //         script.setAttribute('data-queueit-intercept', 'true');
    //         script.setAttribute('data-queueit-c', 'tmturkiye');
        
    //         script.onload = () => resolve(true);
    //         script.onerror = (error) => {
    //         console.error('Error loading script:', error);
    //         reject(error);
    //         };
    //         script.src = source;
    //         document.head.appendChild(script);
    //     });
    // }

    

      getHostName(): string {
        return this.window.location.hostname;
    }
    // initSeo() {
    //     //TODO:Dil desteği verilecek
    //     this.seo.setTags({
    //         title: 'Biletix Eglenceye giris biletiniz... ', // Title
    //         titleSuffix: '', // Title Suffix
    //         description: 'Biletix - Eglenceye giris biletiniz... Biletinizi tek tusla, tek telefonla ve tek adimla alabilirsiniz. Çagri merkezimiz 0850 755 55 55', // Description
    //         image: `favicon.ico`, // Image
    //         keywords: 'biletix, bilet, resmi, spor, maç, müzik, konser, eğlence, tiyatro, festival, sahne sanatları, aile eğlencesi, satışta, eğitim, haftasonu, müze bileti ' // Keywords
    //     });
    // }
}
